import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export function PageMeta() {
	const {
		data: { pageTitle, title, description, photo, fbLocale },
	} = usePageMeta();

	return (
		<>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="twitter:card" content="summary_large_image" />
				<meta property="og:locale" content={fbLocale} />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
				<meta property="twitter:image:alt" content={title} />
			</Helmet>
			{photo ? (
				<Helmet>
					<meta property="og:image" content={photo.url} />
					<meta property="og:image:secure_url" content={photo.url} />
					<meta property="og:image:width" content={`${photo.width}`} />
					<meta property="og:image:height" content={`${photo.height}`} />
					<meta property="twitter:image" content={photo.url} />
				</Helmet>
			) : (
				<Helmet>
					<meta property="og:image" content="https://static.change.org/images/default-petition.gif" />
					<meta property="og:image:secure_url" content="https://static.change.org/images/default-petition.gif" />
					<meta property="og:image:width" content="1120" />
					<meta property="og:image:height" content="630" />
					<meta property="twitter:image" content="https://static.change.org/images/default-petition.gif" />
				</Helmet>
			)}
		</>
	);
}
